module.exports = __webpack_public_path__ + "img/124.e16585a2.jpg";